import { guildApi } from './guildApi'

/** Activity in this browser and speech reset AFK. An outgoing stream/camera is checked by the server. */
export function startVoiceActivity(current: () => { channelId: string | null; sessionId: string | null; speaking: boolean }, subscribeSpeech?: (active: () => void) => () => void): () => void {
  let lastInput = Date.now()
  const active = () => { lastInput = Date.now() }
  const offSpeech = subscribeSpeech?.(active)
  const inputs = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'] as const
  for (const event of inputs) window.addEventListener(event, active, { capture: true, passive: true })
  const timer = setInterval(() => {
    const state = current()
    if (state.speaking) active()
    if (state.channelId && state.sessionId && Date.now() - lastInput < 35_000) {
      void guildApi.voiceActivity(state.channelId, state.sessionId).catch(() => {})
    }
  }, 20_000)
  return () => { offSpeech?.(); clearInterval(timer); for (const event of inputs) window.removeEventListener(event, active, { capture: true }) }
}
